var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home",staticStyle:{"margin-top":"-100px"}},[_c('div',{ref:"chart",staticStyle:{"width":"100%","height":"400px"},attrs:{"id":"main"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }